export function roundDown(x: number, toNearest: number = 1): number {
  return Math.floor(x / toNearest) * toNearest
}

export function roundUp(x: number, toNearest: number = 1): number {
  return Math.ceil(x / toNearest) * toNearest
}

// clamps a value to a min/max val and returns it
// Note: This implementation is faster than lodash's clamp function
export function clamp(val: number, min: number, max: number): number {
  return Math.min(Math.max(val, min), max)
}

/**
 * Calculates the weighted average of an array of values.
 * @param {Array} array - The array of values.
 * @param {number} growthFactor - The growth factor used for assigning weights.
 * @returns {number} - The weighted average of the values.
 */
export function calculateWeightedAverage(array: number[], growthFactor: number) {
  let weightedSum = 0
  let totalWeight = 0
  let arrayLength = array.length

  let weight
  let value
  let weightedValue
  for (let i = 0; i < arrayLength; i++) {
    weight = Math.pow(growthFactor, arrayLength - i - 1)
    value = array[i]
    weightedValue = value * weight

    weightedSum += weightedValue
    totalWeight += weight
  }

  return weightedSum / totalWeight
}

export function createLinearScale(initialDomain: [number, number], initialRange: [number, number]) {
  let domain = initialDomain
  let range = initialRange

  const scale = (value: number): number => {
    if (typeof value !== 'number') return NaN

    const [d0, d1] = domain
    const [r0, r1] = range

    const domainSpan = d1 - d0
    const rangeSpan = r1 - r0

    if (!isFinite(domainSpan) || domainSpan === 0) return r0

    const ratio = (value - d0) / domainSpan
    const result = r0 + ratio * rangeSpan

    if (!isFinite(result)) return isFinite(r1) ? r1 : r0
    return result
  }

  scale.domain = (value: [number, number]) => {
    domain = value
    return scale
  }

  scale.range = (value: [number, number]) => {
    range = value
    return scale
  }

  return scale
}
